import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgress, Modal } from '@mui/material';

const LoaderSpinner = ({ isOpen }) => {
  return (
    <Modal
      disableEnforceFocus
      open={isOpen}
      // onClose={() => setIsOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CircularProgress sx={{ position: 'absolute', top: '50%', right: '50%' }} />
    </Modal>
  );
};

LoaderSpinner.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired
};

export default LoaderSpinner;
